<script lang="ts" setup>
import type { HTMLAttributes } from 'vue'
import { cn } from '@/lib/utils'

const props = defineProps<{
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <ol
    :class="
      cn(
        'my-2 -mr-4 flex items-center gap-1.5 overflow-x-auto whitespace-nowrap py-2 pr-4 text-sm font-semibold sm:gap-2.5',
        props.class
      )
    "
  >
    <slot />
  </ol>
</template>
